export default {
	game: {
		maintenance: 'Dalam Penyelenggaraan',
		maintenance_tip: 'Sementara tidak tersedia',
		no_more_data: 'Tiada data lagi',
		search_game_name: 'Cari nama permainan...',
		selected: 'Dipilih',
		type: 'Jenis',
		all_types: 'Semua Jenis',
		secondary: 'Sekunder',
		secondary_category: 'Kategori Sekunder',
		no_related_games: 'Tiada permainan berkaitan ditemui',
		reset_all: 'Tetapkan Semula Semua',
		end_of_list: 'Akhir Senarai',
		game_details: 'Butiran Permainan',
		play: 'Main',
		bonus_cannot_wagered: 'Bonus tidak boleh dipertaruhkan',
		entering_game: 'Memasuki permainan, sila tunggu...',
		entering_game_short: 'Memasuki Permainan...',
		game_types: 'Jenis Permainan',
		game_providers: 'Penyedia Permainan',
		sign_up: 'Daftar',
		search: 'Cari',
		all_providers: 'Semua Penyedia',
		loading: 'Memuatkan...',
		my_bet: 'Taruhan Saya'
	}
};